import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/act-install/",
          "title": "ACT installation"
        }}>{`A snippet`}</MDXTag>{` of shell commands to install ACT`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-sh"
        }}>{`# install a Gatsby CLI globally (if not already installed)
npm install -g gatsby-cli

# create a new blog site using an ACT starter 
gatsby new my-blog-name https://github.com/act-labs/gatsby-starter-act-blog

# change to the newly created project directory
cd my-blog-name

# install all dependencies
npm install
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "ACT installation",
  "keywords": "ACT, installation",
  "menu": "act blog/install"
};
    